import { connect } from 'react-redux';
import AddNewViolationDialog from './AddNewViolationDialog';
import { getLoggedInUser } from '../../../../store/selectors/authentication.selectors';

import { getCategoryListBegin, getInspectionListBegin } from '../../../../store/actions/license.actions';
import { getCategoryList, getInspectionList } from '../../../../store/selectors/license.selectors';

const mapStateToProps = (state: any) => {
    const categories = getCategoryList(state);
    const inspectionList = getInspectionList(state);
    const loggedInUser = getLoggedInUser(state);

    return {
        categories,
        inspectionList,
        loggedInUser,
    };
};
const mapDispatchToProps = {
    getCategoryList: getCategoryListBegin,
    getInspectionList: getInspectionListBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewViolationDialog);
